export default __webpack_public_path__ + "static/speaker2-4b0f38bd88eff749071b3ed762e14ffd.jpg";